import { ClientLeadsView } from '@/components/client/ClientLeadsView';

const Leads = () => {
  return <ClientLeadsView />;
};

export default Leads;